import {featureCollection as FeatureCollection} from "@turf/turf";

export class GeoJSONDataShed {
  constructor(features) {
    if (!features) {
      features = []
    }

    this._features = features
  }

  setAll(schoolId, features) {
    this._features = features
  }

  getAll() {
    return FeatureCollection(this._features)
  }

  /**
   * Returns a deep copy of all features.
   *
   * @returns {Array} Deep copy of features array.
   *
   * IMPORTANT: This method returns a DEEP COPY (not a reference) because:
   * 1. Fan pattern (fanPattern.js) transforms features for horizontal floor display
   * 2. Components filter/spread/modify returned features
   * 3. Mutations must not leak back to the store's internal state
   *
   * Contrast with getAll() in DataShed which returns a stable reference.
   */
  getFeatures() {
    return this._features.map(f => structuredClone(f))
  }

  add(feature) {
    if (!feature) {
      return
    }

    this.addBulk([feature])
  }

  addBulk(features) {
    if (!features?.length) {
      return
    }

    const ids = features.map(f => f.properties.id)
    this._features = [...this._features.filter(f => !ids.includes(f.properties.id)), ...features]
  }

  remove(id) {
    if (!id) {
      return
    }

    this.removeBulk([id])
  }

  removeBulk(ids) {
    if (!ids?.length) {
      return
    }

    this._features = this._features.filter(f => !ids.includes(f.properties.id))
  }

  clear() {
    this._features = []
  }
}